
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import Login from './Login';
import Register from './Register';
import ForgottenPassword from './ForgottenPassword';
import ResetPassword from './ResetPassword';
import Dashboard from './Dashboard';
import Chapters from './Chapters';
import Blitz from './Blitz';
import ProjectUpload from './ProjectUpload';
import Settings from './Settings';
import OAuthCallback from './OAuthCallback';
import InvitationPage from './InvitationPage';
import Terms from './Terms';
import Privacy from './Privacy';
import Contact from './Contact';
import Docs from './Docs';
import Extensions from './Extensions';
import ShareManagement from './ShareManagement';
import ProjectSettings from './ProjectSettings';
import ProtectedRoute from './components/ProtectedRoute';
import CompatibilityBanner from './components/CompatibilityBanner';
import OfflineBanner from './components/OfflineBanner';
import UpdatePrompt from './components/UpdatePrompt';
import { bootstrapPlaybackSync } from './utils/playbackSyncBootstrap';

function App() {
  useEffect(() => {
    bootstrapPlaybackSync();

    // T063: Clear stale OAuth state on app mount (10 minute timeout)
    const OAuth_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes
    const initiatedAt = sessionStorage.getItem('google_oauth_initiated_at');

    if (initiatedAt) {
      const elapsed = Date.now() - parseInt(initiatedAt, 10);
      if (elapsed > OAuth_TIMEOUT_MS) {
        sessionStorage.removeItem('google_oauth_state');
        sessionStorage.removeItem('google_oauth_flow');
        sessionStorage.removeItem('google_oauth_initiated_at');
      }
    }
  }, []);

  return (
    <Router>
      <CompatibilityBanner />
      <OfflineBanner />
      <UpdatePrompt />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgotten-password" element={<ForgottenPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/oauth/callback" element={<OAuthCallback />} />
        <Route path="/invitations/:token" element={<InvitationPage />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/extensions" element={<Extensions />} />
        <Route
          path="/shares"
          element={
            <ProtectedRoute>
              <ShareManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/chapters"
          element={
            <ProtectedRoute>
              <Chapters />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/upload"
          element={
            <ProtectedRoute>
              <ProjectUpload />
            </ProtectedRoute>
          }
        />
        <Route
          path="/blitz/:projectId"
          element={
            <ProtectedRoute>
              <Blitz />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/settings"
          element={
            <ProtectedRoute>
              <ProjectSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
